import 'g2fw/dist/g2fw.css';
import { g2fwInit } from 'g2fw';
import log from 'loglevel';

g2fwInit();

// trace, debug, info, warn, error
log.setDefaultLevel((process.env.G2FW_BPMS_LOG_LEVEL ?? 'info') as log.LogLevelDesc);